import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, url, type = "website", image = "https://www.expeditio.world/logo.png" }) => {
  const defaultTitle = "AI Travel Planner in India | Free Itinerary Generator | Expeditio";
  const defaultDescription = "Expeditio is an AI-powered travel planner that generates instant hourly, one-day, and multi-day itineraries. Plan smarter trips across India with AI.";
  const siteUrl = "https://www.expeditio.world";
  
  const seoTitle = title ? title : defaultTitle;
  const seoDescription = description || defaultDescription;
  
  // Clean URL to prevent double slashes
  const cleanUrl = url?.startsWith('/') ? url : `/${url || ''}`;
  const canonicalUrl = url ? `${siteUrl}${cleanUrl}` : `${siteUrl}/`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
